import { getRequest, postRequest, putRequest, deleteRequest } from '../services/http';

export const getDishAttributeNames = async (token) => {
  try {
    const response = await getRequest({
      url: `dish-attribute-names/`,
      token: token,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createDishAttributeName = async (data) => {
  try {
    const response = await postRequest({
      url: `dish-attribute-names/`,
      token: data.token,
      data: { name: data.name },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDishAttributes = async (data) => {
  try {
    const response = await getRequest({
      url: `user/branch-stores/${data.storeId}/dish-attributes/`,
      token: data.token,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const createDishAttribute = async (data) => {
  try {
    const response = await postRequest({
      url: `user/branch-stores/${data.storeId}/dish-attributes/`,
      token: data.token,
      data: data.payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateDishAttribute = async (data) => {
  try {
    const response = await putRequest({
      url: `user/branch-stores/${data.storeId}/dish-attributes/${data.id}/`,
      token: data.token,
      data: data.payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteDishAttribute = async (data) => {
  try {
    const response = await deleteRequest({
      url: `user/branch-stores/${data.storeId}/dish-attributes/${data.id}/`,
      token: data.token,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
